<template>
  <div class="container mt-4 mb-5">
    <h1 class="ln-doc-title ln-darkblue mb-4">Prieinamumo pareiškimas</h1>

    <section class="mb-4">
      <h2 class="ln-subtitle-text ln-darkblue">Taikymo sritis</h2>
      <p>Šis pareiškimas taikomas šios interneto svetainės — teisinių dokumentų paieškos ir peržiūros portalo — naudotojo sąsajai.</p>
    </section>

    <section class="mb-4">
      <h2 class="ln-subtitle-text ln-darkblue">Naudojimosi galimybės</h2>
      <p>Siekiame, kad mūsų svetainė būtų kuo patogesnė ir prieinamesnė visiems vartotojams, įskaitant asmenis su negalia ir naudojančius pagalbines technologijas.</p>
      <p>Portalo paieška, navigacija ir formos pritaikytos naudojimui klaviatūra ir ekrano skaitytuvais.</p>
    </section>

    <section class="mb-4">
      <h2 class="ln-subtitle-text ln-darkblue">Teisinis pagrindas</h2>
      <p>Svetainė kuriama ir palaikoma vadovaujantis:</p>
      <ul>
        <li>Europos Parlamento ir Tarybos direktyva (ES) 2016/2102;</li>
        <li>standartu EN 301 549 v3.2.1 (žiniatinklio turiniui);</li>
        <li>WCAG 2.1 lygiu AA.</li>
      </ul>
    </section>

    <section class="mb-4">
      <h2 class="ln-subtitle-text ln-darkblue">Atitikties lygis</h2>
      <p>Ši svetainė dalinai atitinka EN 301 549 v3.2.1 reikalavimus žiniatinklio turiniui, t. y. WCAG 2.1 lygio AA kriterijus.</p>
      <p>Portalo sąsaja (paieška, rezultatų sąrašas, navigacija, prisijungimas) kurta ir tikrinama siekiant šių reikalavimų.</p>
    </section>

    <section class="mb-4">
      <h2 class="ln-subtitle-text ln-darkblue">Ką įgyvendinome portalo sąsajoje</h2>
      <ul>
        <li>meniu, paieška ir formos valdomos klaviatūra;</li>
        <li>nuoroda „Pereiti prie pagrindinio turinio” — klaviatūra (Tab, Enter) galite iš karto pereiti prie paieškos, rezultatų sąrašo ar dokumento teksto, neperėjus antraštės;</li>
        <li>mygtukai ir nuorodos turi aiškius pavadinimus;</li>
        <li>tekstas ir mygtukai parinkti taip, kad būtų lengviau skaityti (pakankamas kontrastas);</li>
        <li>puslapiai pateikiami lietuvių kalba;</li>
        <li>suderinama su pagrindinėmis pagalbinėmis technologijomis (ekrano skaitytuvais).</li>
      </ul>
    </section>

    <section class="mb-4">
      <h2 class="ln-subtitle-text ln-darkblue">Grįžtamasis ryšys</h2>
      <p v-if="feedbackEmail">Jei susidūrėte su prieinamumo kliūtimis arba pastebėjote neatitikimų, praneškite el. paštu:
        <a :href="`mailto:${feedbackEmail}`" class="ln-primary" style="text-decoration:underline;" aria-roledescription="Nuoroda">{{ feedbackEmail }}</a>.
      </p>
      <p>Prašome nurodyti:</p>
      <ul>
        <li>puslapio adresą (URL);</li>
        <li>problemos aprašymą;</li>
        <li>naudojamą naršyklę ar pagalbinę technologiją (jei aktualu).</li>
      </ul>
    </section>

    <section class="mb-4">
      <h2 class="ln-subtitle-text ln-darkblue">Pareiškimo data</h2>
      <p>Pareiškimas parengtas: 2026-06-05</p>
      <p>Paskutinį kartą atnaujintas: 2026-06-05</p>
    </section>
  </div>
</template>

<script>
import appconfig from "../_Services/appconfig.js";

export default {
  name: 'accessibility-page',
  computed: {
    feedbackEmail() {
      return appconfig.feedbackEmail || null;
    },
  },
};
</script>
